"use strict";
var $ = require("../internals/export");
var uncurryThis = require("../internals/function-uncurry-this-clause");
var getOwnPropertyDescriptor = require("../internals/object-get-own-property-descriptor").f;
var toLength = require("../internals/to-length");
var toString = require("../internals/to-string");
var notARegExp = require("../internals/not-a-regexp");
var requireObjectCoercible = require("../internals/require-object-coercible");
var correctIsRegExpLogic = require("../internals/correct-is-regexp-logic");
var IS_PURE = require("../internals/is-pure");
var stringSlice = uncurryThis("".slice);
var min = Math.min;
var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic("startsWith");
var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function() {
  var descriptor = getOwnPropertyDescriptor(String.prototype, "startsWith");
  return descriptor && !descriptor.writable;
}();
$({ target: "String", proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  startsWith: function startsWith(searchString) {
    var that = toString(requireObjectCoercible(this));
    notARegExp(searchString);
    var index = toLength(min(arguments.length > 1 ? arguments[1] : void 0, that.length));
    var search = toString(searchString);
    return stringSlice(that, index, index + search.length) === search;
  }
});
